<template>
    <v-layout row wrap>
      <v-flex xs10 offset-1>
        <v-card outlined color = "lightgray">
            <v-card-title >
                Users activity
            </v-card-title>
          <v-card-text>
              <v-layout row wrap style="font-weight: bold;">
                <v-flex xs1> 
                  order
                </v-flex>
                <v-flex xs2> 
                  time
                </v-flex>
                <v-flex xs2>
                  user
                </v-flex>
                <v-flex xs7> 
                  action
                </v-flex>
              </v-layout>
              <v-layout row wrap v-for="(activity, index) in activityList" :key="index"> 
                <v-flex xs1> 
                  {{index+1}}.
                </v-flex>
                <v-flex xs2> 
                  {{activity.time}}
                </v-flex>
                <v-flex xs2> 
                  {{activity.name}}
                </v-flex>
                <v-flex xs7> 
                  {{activity.action}}
                </v-flex>
              </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
  </v-layout>
</template>

<script>
import axios from '../../axios-auth.js'

  export default {
    data() {
      return {
        activityList: null,
      }
    },
    mounted () {
      this.initData()
   },
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'Users activity', href: '/users_activity'}])//#
      this.getMyLeaders()
    },
    getMyLeaders() {
      axios.get('/get-users-activity', this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            this.activityList = res.data.list
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
   }
  }
</script>

<style>

</style>